import { ApiParameter, post, request, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface FileAttachments {
    [key: string]: File;
}

export interface ReturnRMADataFiles {
    attachment?: FileAttachments;
}

const endpointUrl = "/Utility/UploadFilesToAzure";
export interface RMAModel {}

export function CustomRMAUploadService(parameter: ReturnRMADataFiles, sageApiKey: string, returnUrl: string) {
    const formData = new FormData();
    Object.entries(parameter?.attachment!).forEach(([key, value], index) => {
        formData.append(`attachment${index + 1}`, value);
    });
    return request<ServiceResult<RMAModel>>(`${returnUrl}${endpointUrl}`, "POST", { APIKey: sageApiKey }, formData);
}
